import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvServerApi = createApi({
  reducerPath: 'lmIptvServerApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV server'],
  endpoints: builder => ({
    getIptvServer: builder.query({
      query: (params) => ({
        url: `/links/iptv-server/`,
        params,
      }),
      providesTags: ['IPTV server'],
    }),

    createIptvServer: builder.mutation({
      query: (data) => ({
        url: '/links/iptv-server/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV server'],
    }),
    updateIptvServer: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/iptv-server/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['IPTV server'],
    }),
    getIptvServerById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/iptv-server/${id}/`,
        params,
      }),
      providesTags: ['IPTV server']
    }),
    markIptvContentRemoved: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/iptv-server/${id}/mark-content-removed/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['IPTV server'],
    }),
  }),
});

export const {
  useGetIptvServerQuery,
  useLazyGetIptvServerQuery,
  useCreateIptvServerMutation,
  useUpdateIptvServerMutation,
  useGetIptvServerByIdQuery,
  useLazyGetIptvServerByIdQuery,
  useMarkIptvContentRemovedMutation
} = lmIptvServerApi;
